import translate from '@/utils/translate';

export function computeBulkFlashStatus(
  successCount: number,
  failedCount: number
): 'success' | 'warning' | 'error' {
  if (failedCount === 0) return 'success';
  if (successCount > 0) return 'warning';
  return 'error';
}

export function countBulkFailures(
  failures: Record<string, string[] | undefined>
): number {
  return Object.values(failures).reduce(
    (sum, ids) => sum + (ids?.length ?? 0),
    0
  );
}

interface BulkFlashMessageKeys {
  allSuccess: string;
  partial: string;
  allFailed: string;
}

export function computeBulkFlashMessage(
  successCount: number,
  failedCount: number,
  keys: BulkFlashMessageKeys
): string {
  if (failedCount === 0) {
    return translate(keys.allSuccess, {count: successCount});
  }
  if (successCount > 0) {
    return translate(keys.partial, {successCount, failedCount});
  }
  return translate(keys.allFailed, {count: failedCount});
}
